import { FC, useContext, useEffect, useState } from "react";
import { Context } from "../../../index";
import "./SafetySettings.css";
import ArrowRight from "../../../assets/ArrowRight.svg";
import ArrowSub from "../../../assets/arrowDown.svg";
import { AppContext } from "../../../App";
import CheckboxIos from "../../UiLib/CheckboxIos/CheckboxIos";
import UserService from "../../../services/UserService";
import { IGetRole } from "../../../common/api_interfaces/role/IGetRole";
import { IEditElemSettings } from "../../../common/api_interfaces/settings/IElemSettings";

const SafetySettings: FC = (index) => {
    const { store } = useContext(Context);
    const [allSystemRoles, setAllSystemRoles] = useState<IGetRole[]>();
    const [allProjectRoles, setAllProjectRoles] = useState<IGetRole[]>();
    const [allEmails, setAllEmails] = useState<string[]>();
    const [chooseSystemRole, setChooseSystemRole] = useState<IGetRole>();
    const [chooseProjectRole, setChooseProjectRole] = useState<IGetRole>();
    const [showSystemRole, setShowSystemRole] = useState<boolean>(false);
    const [showProjectRole, setShowProjectRole] = useState<boolean>(false);
    const { showToast } = useContext(AppContext);
    const [selectedEmail, setSelectedEmail] = useState<string>();
    const [checkExpirationLicensePeriod, setCheckExpirationLicensePeriod] = useState<boolean>(false);
    const [checkAuthorizationRefusalsDueLackLicenses, setCheckAuthorizationRefusalsDueLackLicenses] =
        useState<boolean>(false);
    const [openEmailSelect, setOpenEmailSelect] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            try {
                const allRoles = await store.getAllRoles();
                const superAdminsEmails = await UserService.getSuperAdminsEmails();
                setAllEmails(superAdminsEmails.data);
                if (allRoles) {
                    let systemRoles: IGetRole[] = [];
                    let projectRoles: IGetRole[] = [];
                    allRoles?.forEach((xx) => {
                        if (xx.requiredProject === 0) {
                            systemRoles.push(xx);
                        } else {
                            projectRoles.push(xx);
                        }
                    });
                    setAllSystemRoles(systemRoles);
                    setAllProjectRoles(projectRoles);
                }
            } catch (err) {
                console.log(err);
            }
        })();
    }, []);

    useEffect(() => {
        getRole();
    }, [allSystemRoles, allProjectRoles]);

    function getRole() {
        (async () => {
            try {
                const chooseRoles = await store.getSystemSettings();

                if (!chooseRoles?.length) {
                    return showToast("У вас нет доступа к списку ролей!");
                }

                let chooseSystemRole = chooseRoles.find((xx) => xx.paramName === "systemRole");
                let findSystemRole = allSystemRoles?.find((xx) => xx.id === Number(chooseSystemRole?.value));
                setChooseSystemRole(findSystemRole);

                let chooseProjectRole = chooseRoles.find((xx) => xx.paramName === "projectRole");
                let findProjectRole = allProjectRoles?.find((xx) => xx.id === Number(chooseProjectRole?.value));
                setChooseProjectRole(findProjectRole);

                let expirationLicensePeriod = chooseRoles.find((xx) => xx.paramName === "expirationLicensePeriod");
                setCheckExpirationLicensePeriod(expirationLicensePeriod?.value === "true");

                let authorizationRefusalsDueLackLicenses = chooseRoles.find(
                    (xx) => xx.paramName === "authorizationRefusalsDueLackLicenses"
                );
                setCheckAuthorizationRefusalsDueLackLicenses(authorizationRefusalsDueLackLicenses?.value === "true");

                let chooseEmails = chooseRoles.find((xx) => xx.paramName === "emailToSend");
                setSelectedEmail(chooseEmails?.value);
            } catch (err) {
                console.log(err);
            }
        })();
    }

    function changeSystem(role: IGetRole) {
        (async () => {
            try {
                let data: IEditElemSettings[] = [
                    {
                        paramName: "systemRole",
                        value: String(role.id),
                        fileId: undefined,
                    },
                ];

                const res = await store.editSystemSettings(data);
                getRole();
            } catch (err) {
                console.log(err);
            }
        })();
    }

    function changeProject(role: IGetRole) {
        (async () => {
            try {
                let data: IEditElemSettings[] = [
                    {
                        paramName: "projectRole",
                        value: String(role.id),
                        fileId: undefined,
                    },
                ];

                const res = await store.editSystemSettings(data);
                getRole();
            } catch (err) {
                console.log(err);
            }
        })();
    }

    function changeExpirationLicensePeriod() {
        (async () => {
            try {
                let data: IEditElemSettings[] = [
                    {
                        paramName: "expirationLicensePeriod",
                        value: String(!checkExpirationLicensePeriod),
                        fileId: undefined,
                    },
                ];

                const res = await store.editSystemSettings(data);

                getRole();
            } catch (err) {
                console.log(err);
            }
            setOpenEmailSelect(false);
        })();
    }

    function changeAuthorizationRefusalsDueLackLicenses() {
        (async () => {
            try {
                let data: IEditElemSettings[] = [
                    {
                        paramName: "authorizationRefusalsDueLackLicenses",
                        value: String(!checkAuthorizationRefusalsDueLackLicenses),
                        fileId: undefined,
                    },
                ];

                const res = await store.editSystemSettings(data);

                getRole();
            } catch (err) {
                console.log(err);
            }
            setOpenEmailSelect(false);
        })();
    }

    function changeEmail(email: string) {
        (async () => {
            try {
                let data: IEditElemSettings[] = [
                    {
                        paramName: "emailToSend",
                        value: String(email),
                        fileId: undefined,
                    },
                ];

                const res = await store.editSystemSettings(data);

                getRole();
            } catch (err) {
                console.log(err);
            }
            setOpenEmailSelect(false);
        })();
    }

    return (
        <div className="safety__settings">
            <div className="settings-block">
                <div className="text-header">
                    {"Лицензионные настройки"}
                </div>
                <div className="safety__settings--pod">
                    <label className="safety__settings--header__settings">
                        Отправлять уведомления о истечении периода действия лицензии
                    </label>
                    <CheckboxIos callBack={() => changeExpirationLicensePeriod()} checked={checkExpirationLicensePeriod} />
                </div>
                <div className="safety__settings--pod">
                    <label className="safety__settings--header__settings">
                        Отправлять уведомления о случаях отказа в авторизации по причине недостатка лицензий
                    </label>
                    <CheckboxIos
                        callBack={() => changeAuthorizationRefusalsDueLackLicenses()}
                        checked={checkAuthorizationRefusalsDueLackLicenses}
                    />
                </div>
                <div className="safety__settings--pod">
                    <label className="safety__settings--header__settings">Почта для отправки уведомлений</label>
                    <div className="safety__settings--choose--role" onClick={() => setOpenEmailSelect(!openEmailSelect)}>
                        <div className="safety__settings--choose--role__curent">
                            {selectedEmail?.length ? selectedEmail : "Выберите email"}
                        </div>
                        <img
                            className="safety__settings--choose--role__current--arrow"
                            src={openEmailSelect ? ArrowRight : ArrowSub}
                        />
                        {openEmailSelect ? (
                            <div className="safety__settings--choose__modal--size">
                                <div
                                    className="safety__settings--choose__modal--leave"
                                    onClick={() => setOpenEmailSelect(!openEmailSelect)}
                                ></div>
                                <div className="safety__settings--choose__modal">
                                    {allEmails?.map((xx) => (
                                        <div
                                            className="safety__settings--choose__modal--elem"
                                            onClick={() => changeEmail(xx)}
                                        >
                                            {xx}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            {/* {openEmailSelect ? (
                <div className="full-screen-overlay__board--width">
                    <div
                        style={{}}
                        className="full-screen-overlay__board"
                        onClick={() => setOpenEmailSelect(!openEmailSelect)}
                    ></div>
                    <div
                        className={
                            "safety__settings--header__settings"
                        }
                    >
                        {allEmails?.map((xx) => (
                            <div
                                className="safety__settings--header__settings"
                                onClick={() => changeEmail(xx)}
                            >
                                {xx}
                            </div>
                        ))}
                    </div>
                </div>
            ) : null} */}
            <div className="settings-block">
                <div className="text-header">
                    {"Пользовательские настройки"}                
                </div>
                <div className="safety__settings--pod">
                    <div className="safety__settings--header__settings">
                        Автоматически выдавать роль пользователю в системе:
                    </div>
                    <div className="safety__settings--choose--role" onClick={() => setShowSystemRole(!showSystemRole)}>
                        <div className="safety__settings--choose--role__curent">{chooseSystemRole?.roleName}</div>
                        <img
                            className="safety__settings--choose--role__current--arrow"
                            src={showSystemRole ? ArrowRight : ArrowSub}
                        />
                        {showSystemRole ? (
                            <div className="safety__settings--choose__modal--size">
                                <div
                                    className="safety__settings--choose__modal--leave"
                                    onClick={() => setShowSystemRole(!showSystemRole)}
                                ></div>
                                <div className="safety__settings--choose__modal">
                                    {allSystemRoles?.map((xx) => (
                                        <div
                                            className="safety__settings--choose__modal--elem"
                                            onClick={() => changeSystem(xx)}
                                        >
                                            {xx.roleName}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="safety__settings--pod">
                    <div className="safety__settings--header__settings">
                        Автоматически выдавать создателю проекта роль в проекте:
                    </div>
                    <div className="safety__settings--choose--role" onClick={() => setShowProjectRole(!showProjectRole)}>
                        <div className="safety__settings--choose--role__curent">{chooseProjectRole?.roleName}</div>
                        <img
                            className="safety__settings--choose--role__current--arrow"
                            src={showProjectRole ? ArrowRight : ArrowSub}
                        />
                        {showProjectRole ? (
                            <div className="safety__settings--choose__modal--size">
                                <div
                                    className="safety__settings--choose__modal--leave"
                                    onClick={() => setShowProjectRole(!showProjectRole)}
                                ></div>
                                <div className="safety__settings--choose__modal">
                                    {showProjectRole &&
                                        allProjectRoles?.map((xx) => (
                                            <div
                                                className="safety__settings--choose__modal--elem"
                                                onClick={() => changeProject(xx)}
                                            >
                                                {xx.roleName}
                                            </div>
                                        ))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SafetySettings;
